import { API_BASE_URL } from "../../config";

// Shared loaders for the per-customer numbers shown on the ร้านค้า list (CustomerDataManagement),
// the map popup (DashMap/StoreMarkers) and the edit page — one definition so the three screens
// can never disagree. A failed call resolves to null (never to an empty result) so a screen can
// tell "ยังโหลดไม่เสร็จ" / "โหลดไม่สำเร็จ" / "ไม่มีข้อมูลจริง" apart — an empty-but-ok result is the
// only thing that may be shown as "ไม่มีข้อมูล".

export const toISO = (d) => {
    const pad = (x) => String(x).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

// purchase-ranking window → { customerUid: { bagsPerWeek, customerClass } }, plus the raw
// customer list for callers that need membership (ซื้อวันนี้). null when the call failed.
export function fetchPurchaseRanking(token, startDate, endDate) {
    return fetch(`${API_BASE_URL}/saledata/api/module/customers/purchase-ranking?startDate=${toISO(startDate)}&endDate=${toISO(endDate)}`, {
        headers: authHeaders(token),
    }).then(r => r.ok ? r.json() : null).catch(() => null);
}

// เฉลี่ยการซื้อ = trailing 7-day window (a 30-day window took ~14s server-side; bagsPerWeek is
// already normalized per week, so 7 days is an equally valid average — see CustomerDataManagement).
export function trailing7Range(today = new Date()) {
    const start = new Date(today);
    start.setDate(start.getDate() - 7);
    return [start, today];
}

export function buildPurchaseMap(ranking) {
    const purchaseMap = {};
    (ranking?.customers || []).forEach(e => {
        purchaseMap[e.customerId] = { bagsPerWeek: e.bagsPerWeek, customerClass: e.customerClass };
    });
    return purchaseMap;
}

export function fetchRutineAll(token) {
    return fetch(`${API_BASE_URL}/customer/api/customer-buy-rutine/all`, {
        headers: authHeaders(token),
    }).then(r => r.ok ? r.json() : null).catch(() => null);
}

// สายที่รับผิดชอบ — rutine/all rows → { customerUid: [{ sellerUsername, sellerName }] }.
// Needs one more call (seller-names) for the display names, so it runs after the rutine fetch.
export async function buildRouteMap(token, rutineRes) {
    const routeMap = {};
    try {
        const rows = Array.isArray(rutineRes) ? rutineRes : [];
        const sellerIds = [...new Set(rows.map(r => r.sellerId).filter(Boolean))];
        const sellerNameMap = {};
        if (sellerIds.length > 0) {
            const namesRes = await fetch(`${API_BASE_URL}/customer/api/customers/seller-names`, {
                method: 'POST',
                headers: { ...authHeaders(token), 'Content-Type': 'application/json' },
                body: JSON.stringify(sellerIds),
            });
            const namesList = namesRes.ok ? await namesRes.json() : [];
            namesList.forEach(n => { sellerNameMap[n.Seller_ID] = n.nameuser; });
        }
        rows.forEach(r => {
            (routeMap[r.customerId] = routeMap[r.customerId] || []).push({
                sellerUsername: r.sellerId,
                sellerName: sellerNameMap[r.sellerId] || r.sellerId,
            });
        });
    } catch (e) {
        console.error('Failed to resolve seller names for customer-buy-rutine:', e);
    }
    return routeMap;
}

export async function fetchRouteMap(token) {
    return buildRouteMap(token, await fetchRutineAll(token));
}
